//
//
//
//
//
//

import {mapGetters} from 'vuex';
import axios from 'axios';
export default {
  name: 'App',
  data(){
    return{
       time:''
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue